'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwImage = require('../cwimage/CwImage');

var _CwImage2 = _interopRequireDefault(_CwImage);

var _Header = require('./Header.scss');

var _Header2 = _interopRequireDefault(_Header);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The head rests atop the calendar and deals with month changes and
 * displays month and year information.
 */
var Header = function Header(props) {

	//Move the date back a year
	var leftArrowClick = function leftArrowClick() {
		var date = props.value;
		date.month(date.month() - 1);
		props.onClick(date);
	};

	//Move the date forward a year
	var rightArrowClick = function rightArrowClick() {
		var date = props.value;
		date.month(date.month() + 1);
		props.onClick(date);
	};

	var date = props.value;
	var month = date.month();
	var year = date.year();

	return _react2.default.createElement(
		'div',
		{ className: _Header2.default.wrap },
		_react2.default.createElement(_CwImage2.default, { className: _Header2.default.icon, src: props.leftArrow, onClick: leftArrowClick }),
		_react2.default.createElement(
			'label',
			{ className: _Header2.default.monthYear },
			props.monthName[month],
			' ',
			year
		),
		_react2.default.createElement(_CwImage2.default, { className: _Header2.default.icon, src: props.rightArrow, onClick: rightArrowClick })
	);
};

Header.propTypes = {
	/**
  * A working instance of a moment Object. Note that this value is not the same as the "value" displayed in the
  * DatePicker's text field but instead should represent the date associated with the state in CwDatePicker.
  */
	value: _propTypes2.default.instanceOf(_moment2.default),
	/**
  * An array of localized months
  */
	monthName: _propTypes2.default.array,
	/**
  * url for the left arrow image
  */
	leftArrow: _propTypes2.default.string,
	/**
  * url for the right arrow image
  */
	rightArrow: _propTypes2.default.string,
	/**
  * A function responsible for handling the arrow clicks in the header
  */
	onClick: _propTypes2.default.func
};

Header.defaultProps = {
	monthName: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};

exports.default = Header;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwdatepicker/Header.js
// module id = 829
// module chunks = 10